<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">{{ name }} {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <filter-select
        class="mt-4"
        id="department-process-datasource-department-filter"
        ref="department-process-datasource-department-filter"
        :placeholder="$t('department.select')"
        :multiple="true"
        :displayCount="3"
        @filter="onDepartmentSearch"
        :selected="form.department"
        @changed="departmentSelect"
        track="_id"
      />

      <filter-select
        class="mt-4"
        id="department-process-datasource-process-filter"
        ref="department-process-datasource-process-filter"
        :placeholder="$t('process.select')"
        :multiple="true"
        :displayCount="3"
        @filter="onProcessSearch"
        :selected="form.process"
        @changed="processSelect"
        track="_id"
      />
      <filter-select
        class="mt-4"
        id="department-process-datasource-datasource-filter"
        ref="department-process-datasource-datasource-filter"
        :placeholder="$t('datasource.select')"
        :multiple="true"
        :displayCount="3"
        @filter="onDatasourceSearch"
        :selected="form.datasource"
        @changed="datasourceSelect"
        track="_id"
      />

      <filter-select
        class="mt-4"
        id="department-process-datasource-datasubject-filter"
        ref="department-process-datasource-datasubject-filter"
        :placeholder="$t('datasubject.select')"
        :multiple="true"
        :isValid="!$v.form.datasubject.$invalid"
        :displayCount="3"
        @filter="onDatasubjectSearch"
        :selected="form.datasubject"
        @changed="datasubjectSelect"
        track="_id"
      />

      <br />
      <sweet-button
        @click="save()"
        type="submit"
        :loading="isUpdating"
        :disabled="
          isUpdating ||
            $v.$invalid ||
            ((!form.department || form.department.length == 0) && (!form.process || form.process.length == 0) && (!form.datasource || form.datasource.length == 0))
        "
        variant="success"
        icon="mdi mdi-check"
        size="sm"
        buttonClass="mt-2"
      >
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "departmentProcessDatasourceDatasubject";

export default {
  props: ["state"],
  data() {
    return {
      form: { department: undefined, process: undefined, datasource: undefined, datasubject: undefined },
    };
  },
  validations: {
    form: {
      datasubject: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    name() {
      const process = this.editedEntity?.process?.name ? this.$options.filters.translate(this.editedEntity?.process?.name) : "";
      const datasource = this.editedEntity?.datasource?.name ? this.$options.filters.translate(this.editedEntity?.datasource?.name) : "";

      return ` ${process}  ${datasource}`;
    },
    isWorkspaceLayout() {
      return this.state === "workspaceDepartmentProcessDatasourceDatasubject";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },
  methods: {
    async save() {
      const childDepartments = this.form.department;
      const processes = this.form.process;
      const childDatasources = this.form.datasource;
      const childDatasubjects = this.form.datasubject;
      this.$emit("onSave", childDepartments, processes, childDatasources, childDatasubjects);
    },

    async onDepartmentSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDepartment" : "managementDepartment";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(this.state == "departmentProcessDatasourceDatasubject" && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    departmentSelect(item) {
      this.form = { ...this.form, department: item };
    },

    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    processSelect(item) {
      this.form = { ...this.form, process: item };
    },
    async onDatasourceSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasource" : "managementDatasource";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    datasourceSelect(item) {
      this.form = { ...this.form, datasource: item };
    },

    async onDatasubjectSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasubject" : "managementDatasubject";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    datasubjectSelect(item) {
      this.form = { ...this.form, datasubject: item };
    },
  },
};
</script>
